import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import './Live.css';
import bgImage from '../styles/img/backgroundNV1.png';

const LiveEvent = () => {
    const intl = useIntl();
    
    // We can default to the current language's stream, but allow the user to switch manually
    const initialStream = intl.locale === 'en-US' ? 'english' : 'spanish';
    const [activeStream, setActiveStream] = useState(initialStream);

    // Apply the same body class as the main event-planned view
    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.classList.add('theme-event-planned');
        return () => {
            document.body.classList.remove('theme-event-planned');
        };
    }, []);

    // Get translations
    const title = intl.formatMessage({ id: 'eventPlannedLiveTitle', defaultMessage: 'En Vivo' });
    const spanishStreamLabel = intl.formatMessage({ id: 'eventPlannedLiveSpanishStream', defaultMessage: 'Transmisión en Español' });
    const englishStreamLabel = intl.formatMessage({ id: 'eventPlannedLiveEnglishStream', defaultMessage: 'Transmisión en Inglés' });
    const slidoButtonText = intl.formatMessage({ id: 'eventPlannedLiveSlidoButton', defaultMessage: 'Envía tu pregunta por Slido' });

    // Vimeo Event IDs
    const vimeoEventId = activeStream === 'spanish' ? '6246884' : '6246960';

    return (
        <div className="supercontent home" id="myApp">
            <section className="herowelcome">
                <img className="bck" src={bgImage} alt="Background" />
                <section className="section banner banner-section" style={{ paddingTop: '100px' }}>
                    <div className="superboxlive">
                        <div className="livetext ff-figtree">
                            {title}
                        </div>

                        <div className="breadcrumbs">
                            <Link to="/organizaciones-con-proposito">Inicio</Link> &gt; <span>{title}</span>
                        </div>

                        <div className="containerlive">
                            <div className="btnsactionlive">
                                <div className="botoneraschangelive">
                                    <div className="btnliveesp">
                                        <a 
                                            href="#"
                                            onClick={(e) => { e.preventDefault(); setActiveStream('spanish'); }}
                                            style={{ 
                                                backgroundColor: activeStream === 'spanish' ? '#0f2230' : '#bbdfff',
                                                color: '#ffffff'
                                            }}
                                        >
                                            {spanishStreamLabel}
                                        </a>
                                    </div> 
                                    <div className="btnliveeng">
                                        <a 
                                            href="#"
                                            onClick={(e) => { e.preventDefault(); setActiveStream('english'); }}
                                            style={{ 
                                                backgroundColor: activeStream === 'english' ? '#0f2230' : '#bbdfff',
                                                color: '#ffffff'
                                            }}
                                        >
                                            {englishStreamLabel}
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                            <section className="sectlive">
                                <div className="boxvideolive">
                                    <div className="videolive" style={{ padding: '56.25% 0 0 0' }}>
                                        <iframe 
                                            src={`https://vimeo.com/event/${vimeoEventId}/embed`} 
                                            frameBorder="0" 
                                            allow="autoplay; fullscreen; picture-in-picture; encrypted-media; web-share" 
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen 
                                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                            title="Live Stream"
                                        ></iframe>
                                    </div>
                                </div>
                                
                                <div className="boxvideochat">
                                    <iframe 
                                        src="https://app.sli.do/event/sPHfiEWJX1JvJUBKFT28Ub" 
                                        height="100%" 
                                        width="100%"
                                        frameBorder="0" 
                                        style={{ minHeight: '560px' }} 
                                        allow="clipboard-write"
                                        title="Slido"
                                    ></iframe>
                                </div>
                            </section>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    );
};

export default LiveEvent;
